export const addresses = {
    // Mainnet
    1: {
        FCT_Controller: "0x35c89b55Fd59C1FfAa29f35861c7C1eADa3777b3",
        FCT_BatchMultiSig: "0xB618b372f4C9E5F1Ae31598C6aFD1277Ab8844D1",
        FCT_EnsManager: "0x6D0AF0D8b98647951D3fb522fF7642F3450b80CA",
        FCT_Tokenomics: "0xd72886aFEE2a81126b8c6Ec8E8F370724aD30703",
        Actuator: "0xf938dDC2af0033D5A022C8aD95206D817d0A3385",
        ActuatorCore: "0x56051665dB9F2b7268E51D6D164e4Be48d1A8517",
        WETH: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    },
    // Arbitrum
    42161: {
        FCT_Controller: "0xEA090815B209371B2EA1404fA2694E64Ca86EE29",
        FCT_BatchMultiSig: "0x1cE596386A12098EE687954b7BFe43898C2821F6",
        FCT_EnsManager: "0xD6cC2a617A483BB8A7836CFCd1c637984B6593d6",
        FCT_Tokenomics: "0x74fE4729C31002C817A2c57cBe67fA37e62CF2F0",
        Actuator: "0x1E9E07156Bb5bB3584Fb60e15a5894Bd5fC88C88",
        ActuatorCore: "0x990591F9A7FbE8279317AA901F2e9c983E1C7A32",
        WETH: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
    },
    // Optimism
    10: {
        FCT_Controller: "0x6fA9FD5650aA8CC060D1F1aa18A6698578762643",
        FCT_BatchMultiSig: "0xEa34C0bF3057D3d2bC97902091c71a8D4c9747DC",
        FCT_EnsManager: "0x01F0EaA49661e09b7395FE18Ea2F7f8827d19D44",
        FCT_Tokenomics: "0xCa292B5770FDD9d2D6A89334A93346584AE5af14",
        Actuator: "0x8A54b1e515aB5A2A5Aa721b47B887095446AaA1a",
        ActuatorCore: "0x3b31B51D6fAf6aCeD84Ab14f760e7AFFe50Cc575",
        WETH: "0x4200000000000000000000000000000000000006",
    },
    // Base
    8453: {
        FCT_Controller: "0x2C6E704Af6C9afA0CCb39999e5556E6769106B80",
        FCT_BatchMultiSig: "0x1B5711F1152A732485ef2B0DE049cd21E5504687",
        FCT_EnsManager: "0x3906bbE4b028b99A695924E275d309981726620c",
        FCT_Tokenomics: "0xCe6E1e8AaF3B6f66FDF95c077779A0F31C47e6Ad",
        Actuator: "0x07ed26c104a1EEAD2bBCEc5ab6877f59519b6A4D",
        ActuatorCore: "0x05a901f8e81f12897EFD63D396AC0a42fC42e011",
        WETH: "0x4200000000000000000000000000000000000006",
    },
    //
    // Testnets
    //
    // Sepolia
    11155111: {
        FCT_Controller: "0xEa34C0bF3057D3d2bC97902091c71a8D4c9747DC",
        FCT_BatchMultiSig: "0xfd9C07D706Ae328896c05bdD80c1F3837867Df27",
        FCT_EnsManager: "0xde841c9344E3C770a59102C8E61AFF699D8c4585",
        FCT_Tokenomics: "0xBc436e7F162B08504307E76396De9B25955F708F",
        Actuator: "0x50EAEBb6611AcBF8138bfaE068d2407Bc08c2C16",
        ActuatorCore: "0x94EE3F762E4B25Fddc1e95Bf20521FE2F6a71f18",
        WETH: "0x7b79995e5f793A07Bc00c21412e50Ecae098E7f9",
    },
    // Arbitrum Goerli (DEPRECATED)
    421613: {
        FCT_Controller: "0x574F4cDAB7ec20E3A37BDE025260F0A2359503d6",
        FCT_BatchMultiSig: "0x3628BE9E0BEfE4406cDFCA72E51d40d3902B9a22",
        FCT_EnsManager: "0x40b3dA447BE499e0D8165b314EB77e2356d0a92f",
        FCT_Tokenomics: "0x4F741c8106a01d7bAd583aB8937B625d662F0530",
        Actuator: "0x0E3b88a54b4ac2cAA5aD69E5B2E8254dB669c5d7",
        ActuatorCore: "0xfE406d3285a6C5D45Dad771aaD1BD7dADcDb00A0",
        WETH: "0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF",
    },
    // Goerli (DEPRECATED)
    5: {
        FCT_Controller: "0x38B5249Ec6529F19aee7CE2c650CadD407a78Ed7",
        FCT_BatchMultiSig: "0x9F8Cc08FC5293D76A0d8B3b0924742FC36a1301c",
        FCT_EnsManager: "0xB9DBD91e7cC0A4d7635d18FB33416D784EBe2524",
        FCT_Tokenomics: "0x47Fca35c6fAb9E90a1ccf2630941fF64866fD3d2",
        Actuator: "0x862A8FB429195d735106c06C4e352E305d8c7B31",
        ActuatorCore: "0x2301F7d5A833395733F92fdf68B8Eb15aC757dF9",
        WETH: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
    },
};
// 0xa58e9728
// 00000000000000000000000000000000000000000000000002d6e6cdfd13f149
// 0000000000000000000000000000000000000000000000000000000000000012
// 00000000000000000000000000000000000000000000000002d3c3d42ee4e74b
// 0000000000000000000000000000000000000000000000000000000000000012
// 0000000000000000000000000000000000000000000000000000000000000012
//# sourceMappingURL=addresses.js.map